import styled from 'styled-components';
import HeaderAction from './component/HeaderAction';
import ListScreen from './component/ListScreen';

const StoreDetailPage = () => {
  return (
    <Container>
      <HeaderAction />
      <ListScreen />
    </Container>
  );
};

export default StoreDetailPage;

const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  padding: 16px;
`;
